import React from 'react';
import PropTypes from 'prop-types';
import ListTableToolbar from './ListTableToolbar';
import ListTable from './ListTable';
import BreadCrumbs from '../BreadCrumbs';
import { Affix, Card } from 'antd';

const ListPage = ({
  title,
  onAdd,
  onSearch,
  onRefresh,
  loading,
  extra,
  data,
  onTableChange,
  pagination,
  columns,
  rowKey,
  breadCrumbItems,
  hideAddAction,
  secondaryExtraContent,
  onSelectRowsfun, // Accept onSelectRows as a prop
  selectedRowKeys,
  footer,
  showApproveFilter,
  onshowApproveFilterChange,
  hasRushstatusFilter,
  setHasRushStatusFilter,
  showHasFilter,
  showProStatusFilter,
  proStatusOnChange,
  proStatusFilterValue,
  initialSearchString,
  searchFieldKey,
  showCheckbox
}) => {
  return (
    <>
      <BreadCrumbs items={breadCrumbItems} />
      <div className="row">
        <div className="col-sm-12">
          <div className="card card-table show-entire">
            <div className="card-body">
              {/* Table Header */}
              <ListTableToolbar
                title={title}
                onAdd={onAdd}
                onRefresh={onRefresh}
                onSearch={onSearch}
                hideAddAction={hideAddAction}
                extra={extra}
                secondaryExtraContent={secondaryExtraContent}
                showApproveFilter={showApproveFilter}
                onshowApproveFilterChange={onshowApproveFilterChange}
                hasRushstatusFilter={hasRushstatusFilter}
                setHasRushStatusFilter={setHasRushStatusFilter}
                showHasFilter={showHasFilter}
                showProStatusFilter={showProStatusFilter}
                proStatusOnChange={proStatusOnChange}
                proStatusFilterValue={proStatusFilterValue}
                initialSearchString={initialSearchString}
                searchFieldKey={searchFieldKey}
              />

              {/* /Table Content */}
              <ListTable
                columns={columns}
                data={data}
                loading={loading}
                pagination={pagination}
                onTableChange={onTableChange}
                rowKey={rowKey}
                onSelectRows={onSelectRowsfun}
                selectedRowKeys={selectedRowKeys}
                showCheckbox={showCheckbox}
              />
            </div>
          </div>
        </div>
      </div>
      {footer ? (
                <Affix offsetBottom={10}>
                  <Card className="d-flex justify-content-start">{footer}</Card>
                </Affix>
              ) : null}
    </>
  );
};

ListPage.propTypes = {
  ...ListTableToolbar.propTypes,
  ...ListTable.propTypes,
  breadCrumbItems: PropTypes.array,
  footer: PropTypes.any,
  showApproveFilter: PropTypes.bool,
  onshowApproveFilterChange: PropTypes.func,
  hasRushstatusFilter: PropTypes.bool,
  setHasRushStatusFilter: PropTypes.func,
  showProStatusFilter: PropTypes.bool,
  proStatusOnChange: PropTypes.func,
  proStatusFilterValue: PropTypes.string,
  initialSearchString: PropTypes.string,
  searchFieldKey: PropTypes.number,
  showCheckbox: PropTypes.bool
};

export default ListPage;
